import React from 'react'
import {useSelector} from "react-redux";
import {useFormFieldAttributes} from "../../utils"
import RawTextField from "./raw_fields/flave_text_field";

const Textfield = ({tagOwner, field, formMode, type}) => {
  const {
    fieldName,
    title,
    fieldMode,
    placeholder,
    hint,
    errorMessage,
    prefill
  } = useFormFieldAttributes(formMode, field)
  return <RawTextField
    name={fieldName}
    label={title || field}
    readOnly={fieldMode === "readonly"}
    defaultValue={prefill ? tagOwner  && tagOwner[field] : ""}
    placeholder={placeholder}
    hint={hint}
    errorMessage={errorMessage}
  />
}

export default Textfield;
